<template>
  <div class ="tpa-sample-company">
    <v-row justify="center" align="center">
      <v-container>
          <div class="text-h3 primary--text text-center">{{tpaContext.tpa.tpa_name}}</div>
      </v-container>
    </v-row>
   
    <v-card class="custom-card" outlined>
      <v-col cols="12" class="pb-0">
          <v-container class="pb-0">
              <v-row no-gutters class="custom-row">
                <v-col cols="6" class="p-0 pr-5">
                    <v-text-field 
                      v-model="tpaContext.tpa.tpa_name"
                      :error-messages="companyNameErrors"
                      label="Company Name"
                      disabled
                      class="pa-0 ma-0">
                    </v-text-field>
                </v-col>
                <v-col cols="3" class="p-0 pl-5">
                    <v-text-field 
                      v-model="tpaContext.tpa.voya_plan"
                      :error-messages="voyaAccountsErrors"
                      label="# of Voya Accounts"
                      outlined dense
                      class="pa-0 ma-0">
                    </v-text-field>
                </v-col>
                <v-col cols="3" class="p-0 pl-5">
                    <v-text-field 
                      v-model="tpaContext.tpa.tpa_short_name"
                      :error-messages="voyaAccountsErrors"
                      label="Company Short Name"
                      outlined dense
                      class="pa-0 ma-0">
                    </v-text-field>
                </v-col>
              </v-row>
              <v-row no-gutters class="custom-row">
                <v-col cols="6" class="p-0 pr-5">
                    <v-text-field 
                      v-model="tpaContext.tpa.tpa_primary_email"
                      :error-messages="primaryEmailErrors"
                      label="Primary Email"
                      class="pa-0 ma-0">
                    </v-text-field>
                </v-col>
                <v-col cols="6" class="p-0 pl-5">
                    <v-text-field 
                      v-model="tpaContext.tpa.tpa_address"
                      :error-messages="companyAddressErrors"
                      label="Company Address"
                      class="pa-0 ma-0">
                    </v-text-field>
                </v-col>
              </v-row>
              <v-row no-gutters class="custom-row">
                <v-col cols="6" class="p-0 pr-5">
                    <v-text-field 
                      v-model="tpaContext.tpa.tpa_primary_phone"
                      :error-messages="primaryPhoneErrors"
                      label="Primary Phone"
                      class="pa-0 ma-0">
                    </v-text-field>
                </v-col>
                <v-col cols="6" class="p-0 pl-5">
                    <v-row no-gutters>
                      <v-col cols="6" class="p-0 pr-5">
                          <v-text-field 
                            v-model="tpaContext.tpa.tpa_city"
                            :error-messages="companyCityErrors"
                            label="Company City"
                            class="pa-0 ma-0">
                          </v-text-field>
                      </v-col>
                      <v-col cols="6" class="p-0 pl-5">
                          <v-text-field 
                            v-model="tpaContext.tpa.tpa_state"
                            :error-messages="companyStateErrors"
                            label="Company State"
                            class="pa-0 ma-0">
                          </v-text-field>
                      </v-col>
                    </v-row>
                </v-col>
              </v-row>
              <v-row no-gutters class="custom-row">
                <v-col cols="6" class="p-0  pr-5">
                    <v-text-field 
                      v-model="tpaContext.tpa.tpa_primary_contactname"
                      :error-messages="primaryContactNameErrors"
                      label="Primary Contact Name"
                      class="pa-0 ma-0">
                    </v-text-field>
                </v-col>
                <v-col cols="6" class="p-0 pl-5">
                    <v-row no-gutters>
                      <v-col cols="6" class="p-0 pr-5">
                          <v-text-field 
                            v-model="tpaContext.tpa.tpa_zip"
                            :error-messages="companyZipCodeErrors"
                            label="Company ZipCode"
                            class="pa-0 ma-0">
                          </v-text-field>
                      </v-col>
                      <v-col cols="6" class="p-0 pl-5" style="text-align:end;">
                          <v-btn color="primary" dark @click="submit">Save Changes</v-btn>
                      </v-col>
                    </v-row>
                </v-col>
              </v-row>
          </v-container>
      </v-col>
    </v-card>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';

  export default {
    data: () => ({
        
    }),

    mounted () {
       this.getTpa();
    },

    computed: {
      ...mapGetters({ 
        tpaContext: 'getTpaContext'
      }),

      companyNameErrors() {
        const errors = [];
        return errors;
      },

      voyaAccountsErrors() {
        const errors = [];
        return errors;
      },

      primaryEmailErrors() {
        const errors = [];
        return errors;
      },

      companyAddressErrors() {
        const errors = [];
        return errors;
      },

      primaryPhoneErrors() {
        const errors = [];
        return errors;
      },

      companyCityErrors() {
        const errors = [];
        return errors;
      },

      companyStateErrors() {
        const errors = [];
        return errors;
      },

      primaryContactNameErrors() {
        const errors = [];
        return errors;
      },

      companyZipCodeErrors() {
        const errors = [];
        return errors;
      },

    },

    methods: {
        ...mapActions(['updateTpa','raiseMessage','getTpa']),
        submit(){
          let tpa = {}
          tpa['tpa'] = this.tpaContext.tpa
          this.updateTpa(tpa);
        }
    },
    components: { },
  };
</script>

<style scoped>

  h1 {
    max-width: 900px;
    margin: 15px auto;
  }

  .custom-card {
    max-width:1200px;
    margin: auto;
    border-radius:50px;
    box-shadow: 0px 0px 5px -2px;
  }

  .custom-row {
    margin-bottom: 15px;
    padding-left: 5px;
    padding-right: 5px;
  }

  .custom-card .custom-row:first-of-type {
    padding-top: 15px;
  }

  .custom-card .custom-row:last-of-type {
    padding-bottom: 20px;
  }
  
  .theme--light.v-sheet--outlined {
        border: thin solid rgb(0,0,0,30%);
    }

</style>